import 'promise-polyfill/src/polyfill'
import 'core-js';
import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package

import L from 'leaflet'
import 'leaflet-defaulticon-compatibility';
import 'leaflet.locatecontrol';

import osmtogeojson from 'osmtogeojson'
import 'leaflet-mouse-position'
import 'leaflet-geocsv'
import axios from 'axios'

import "./search-form.js"
import 'leaflet-mouse-position/src/L.Control.MousePosition.css'
import "../common/js/L.Control.MultiOpacity.js"
import {createTileLayer, createVectorTileLayer} from './layerCreation.js'
import "../common/css/L.Control.MultiOpacity.css"
import "../common/css/leafletwrapper.css"
import "./search-form.css"
import Worker from "./mapColors.worker.js"
import createVueApp from './search-app.js'
import "@maptiler/leaflet-maptilersdk"
import { setAreaBehaviour} from './behaviours.js'
import { fillColors,featureStyleWithConfig } from './style.js'

/* global L, axios */

// Read a map.json file containing

// details
// layers

function getEnv() {
  return (location.href.indexOf('://localhost') > 0 ? 'dev' : 'prod')
}

function getLayersInfo(layers) {
  return layers.filter(l => l.feature.geometry && (l.feature.geometry.type === 'Polygon' || l.feature.geometry.type === 'MultiPolygon'))
    .map(l => {
      return {
        id: l._leaflet_id,
        feature: l.feature,
        bounds: l.getBounds(),
        color: l.options.fillColor
      };
    });
}

/**
 * Given a leaflet GeoJSON layer, go through all the layers within it
 * trying to ensure that if two layers have intersecting bounding
 * boxes that they are using different colors.
 * Do this using a web worker so the main thread is not blocked.
 * We need to transform the data to plain objects to pass it to
 * the web worker. It will respond with only the layer IDs that need
 * to change color.
 * 
 * @param {Leaflet Layer} layer 
 * @param {[String] colors}  fillColors Array of colors to fill with
 */

function fixNeighbourColors(layer, fillColors) {
  if (1==2 && Worker) {
    var layerSummary = getLayersInfo(layer.getLayers())
    var myWorker = new Worker();
    myWorker.onmessage = function (msg) {
      var layersToChange = msg.data;
      layersToChange.forEach(l => {
        layer.getLayer(l.id).setStyle({ fillColor: l.newColor });
      });
    };
    myWorker.postMessage({ fillColors: fillColors, layers: layerSummary });
  }
}

function getGJOptions(config, icons) {
  const gjOptions = {
    style: featureStyleWithConfig(config)
  };
  const labelField = config.labelField
  if (config.showLabels) {
    gjOptions.onEachFeature = setAreaBehaviour(false, labelField, config);
  }
  if (config.permanentLabels) {
    gjOptions.onEachFeature = setAreaBehaviour(true, labelField, config);
  }
  if (config.icon && !icons.has(config.icon)) {
    alert('Icon ' + config.icon + ' for file ' + config.filename + ' does not exist - valid values are:' + Array.from(icons.keys()).join(', '))
    return
  }
  gjOptions.pointToLayer = function (feature, latlng) {
    if (config.hidePoints) {
      return null;
    }
    const title = (typeof geojsonPointTitle == 'function') ? geojsonPointTitle(feature, config) : (labelField ? feature.properties[labelField] : feature.properties.name)
    let icon = (typeof geojsonPointIcon == 'function') ? geojsonPointIcon(feature, icons, config) : null;
    if (!icon && config.icon) icon = icons.get(config.icon);
    if (icon) {
      const marker = L.marker(latlng, {
        icon: icon
      });
      if (title) marker.bindTooltip(title);
      return marker;
    } else {
      const mrkr = L.circleMarker(latlng, { radius: 4 })
      const label = labelField ? feature.properties[labelField] : feature.properties.name;
      if (false && (config.showLabels || config.permanentLabels) && label) {
        mrkr.bindTooltip(
          title,
          {
            permanent: !!config.permanentLabels
          }
        );
      }
      return mrkr;
    }
  };
  return gjOptions;
}

function addGeoJsonFile(geoJson, addTo, fileIndex, icons) {
  const gjOptions = getGJOptions(geoJson, icons)
  return axios
    .get(geoJson.filename)
    .then(response => {
//      const gj = L.geoJson.vt(response.data, gjOptions);

      const gj = L.geoJson(response.data, gjOptions);
      addTo.addLayer(gj);
      fixNeighbourColors(gj, fillColors);
      return gj;
    })
    .catch(e => {
      console.error(e);
      if (e.response && e.response.status === 404) {
        alert('File not found ' + e.response.config.url);
      } else {
        alert('Unexpected error adding GeoJSON file ' + geoJson.filename + ' - see console for details');
      }
    });
}

function getJSONParseError(jsonStr) {
  try {
    JSON.parse(jsonStr);
  } catch (e) {
    const position = Number(e.message.substr(e.message.indexOf('position') + 9));
    const lineNumber = jsonStr.substring(0, position).split('\n').length;
    return (
      'Error parsing map.json - ' +
      e.message +
      '\nLine number: ' +
      lineNumber +
      '\n' +
      jsonStr.substr(position - 5, 10)
    );
  }
}

function addGeoCsv(geoCsv, addTo, icons) {
  return axios
    .get(geoCsv.filename)
    .then(response => {
      const gjOptions = getGJOptions(geoCsv, icons)
      const gc = L.geoCsv(response.data,
        {
          ...gjOptions,
          firstLineTitles: true,
          fieldSeparator: ',',
          onEachFeature: function (feature, layer) {
            var popup = '';
            for (var key in feature.properties) {
              if (key.startsWith('img_'))
                popup += '<a target="markerpopupimage" href="' + feature.properties[key] + '"><img width="100" src="' + feature.properties[key] + '"></a><br>';
              else
                popup += '<b>' + key + '</b>: '+feature.properties[key]+'<br>';
            }
            layer.bindPopup(popup);
          }       
         });
      addTo.addLayer(gc);
      return gc;
    })
    .catch(e => {
      console.error(e);
      if (e.response && e.response.status === 404) {
        alert('File not found ' + e.response.config.url);
      } else {
        alert('Unexpected error adding GeoJSON file ' + geoJson.filename + ' - see console for details');
      }
    });

}

function addOverpassQuery(query, layer, icons) {
  return axios.get("https://overpass-api.de/api/interpreter?data=" + query.url).then(response => {
    const gjOptions = getGJOptions(query, icons)
    const geojson = osmtogeojson(response.data, "flatProperties: true")
    const gj = L.geoJson(geojson, gjOptions);
    layer.addLayer(gj);
    return gj;
  }
  )
}

/**
 * Given an array of layers and a map
 *
 * @param {*} layerDetails Layers to be added
 * @param {*} map          Map to have the layers
 */

function addLayers(layerDetails, map, icons) {
  const layerMap = {};

  layerDetails.forEach(ld => {
    let layer;

    if (ld.tiles) {
      layer = createTileLayer(ld.tiles);
    } else if (ld.vectorTiles) {
      layer = createVectorTileLayer(ld.vectorTiles);
    } else if (ld.overlay) {
      layer = L.imageOverlay(ld.overlay.url, ld.overlay.bounds);
    } else {
      layer = L.featureGroup([]);

      if (ld.overpassQuery) {
        layer.promise = addOverpassQuery(ld.overpassQuery, layer, icons).then(() => { return layer });
      }
      if (ld.geoJsonFile) {
        layer.promise = addGeoJsonFile(ld.geoJsonFile, layer, 0, icons).then(() => { return layer });
      }

      if (ld.geoCsvFile) {
        layer.promise = addGeoCsv(ld.geoCsvFile, layer, icons).then(() => { return layer });
      }

      if (ld.geoJsonFiles && Array.isArray(ld.geoJsonFiles)) {
        ld.geoJsonFiles.map((gj, i) => {
          return addGeoJsonFile(gj, layer, i, icons);
        });
      }
    }

    layer.options.attribution = ld.attribution;

    if (ld.show) {
      layer.addTo(map);
    }

    layerMap[ld.name] = layer;

    return layer;
  });

  return layerMap;
}

function loadDataFile(filename) {
  return axios
    .get(filename ? filename : 'map.json')
    .then(response => {
      if (typeof response.data === 'string') {
        alert(getJSONParseError(response.data));
        return;
      }

      const mapSettings = response.data.settings;

      const iconDefs = response.data.icons || [];

      const icons = new Map(iconDefs.map(id =>
        [id.name, L.icon(id.data)]
      ))

      const mymap = L.map('map', {
        center: [mapSettings.center.lat, mapSettings.center.lng],
        zoom: mapSettings.zoom,
        maxZoom: mapSettings.maxZoom
      });

      if (mapSettings.showCoords) {
        L.control.mousePosition().addTo(mymap)
      }

      const layerMap = addLayers(response.data.layers, mymap, icons)

      const layers = Object.keys(layerMap).map(key => layerMap[key])
      if (mapSettings.showLocator) {
        L.control.locate().addTo(mymap)
      }

      const layerControl = L.control.layers({}, layerMap, {
        collapsed: window.innerHeight < 600 || window.innerWidth < 600
      }).addTo(mymap);

      const geoJsonPromises = layers.filter(l => l.promise).map(l => l.promise)
      Promise.all(geoJsonPromises).then(geoJsonLayers => {
        createVueApp(mymap, geoJsonLayers, mapSettings.searchField);
      });

      // mymap.on('overlayadd', function (e) { 
      //   layerControl.removeLayer(e.layer);
      //   layerControl.addOverlay(e.layer, e.name);
      //   e.layer.bringToFront();
      // });

      L.control.multiOpacity(layers, layerControl, { position: 'bottomleft ' }).addTo(mymap);

      // if (L.control.layerSelector) {
      //   L.control.layerSelector(layerMap, {}).addTo(mymap);
      // }

      return mymap;
    })
    .catch(function (e) {
      console.error('Unexpected error with file ' + filename, e);
    });
}

const inTestMode = location.href.indexOf('test') >= 0;

if (inTestMode) {
  document.body.classList.add('feature-test')
}

window.mapJsonLoaded = loadDataFile();
